export default "__VITE_ASSET__7TxB7xo5__"